/* tslint:disable */
/* eslint-disable */
/**
 * Document API
 * API for managing documents
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LineItemFromJSON, LineItemToJSON, } from './LineItem';
/**
 * Check if a given object implements the UpdateDocumentRequest interface.
 */
export function instanceOfUpdateDocumentRequest(value) {
    return true;
}
export function UpdateDocumentRequestFromJSON(json) {
    return UpdateDocumentRequestFromJSONTyped(json, false);
}
export function UpdateDocumentRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fileTags': json['fileTags'] == null ? undefined : json['fileTags'],
        'vendorName': json['vendorName'] == null ? undefined : json['vendorName'],
        'vendorAddress': json['vendorAddress'] == null ? undefined : json['vendorAddress'],
        'vendorPhone': json['vendorPhone'] == null ? undefined : json['vendorPhone'],
        'vendorUrl': json['vendorUrl'] == null ? undefined : json['vendorUrl'],
        'vendorAbnNumber': json['vendorAbnNumber'] == null ? undefined : json['vendorAbnNumber'],
        'vendorGstNumber': json['vendorGstNumber'] == null ? undefined : json['vendorGstNumber'],
        'vendorPanNumber': json['vendorPanNumber'] == null ? undefined : json['vendorPanNumber'],
        'vendorVatNumber': json['vendorVatNumber'] == null ? undefined : json['vendorVatNumber'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'receiverAddress': json['receiverAddress'] == null ? undefined : json['receiverAddress'],
        'receiverPhone': json['receiverPhone'] == null ? undefined : json['receiverPhone'],
        'receiverAbnNumber': json['receiverAbnNumber'] == null ? undefined : json['receiverAbnNumber'],
        'receiverGstNumber': json['receiverGstNumber'] == null ? undefined : json['receiverGstNumber'],
        'receiverPanNumber': json['receiverPanNumber'] == null ? undefined : json['receiverPanNumber'],
        'receiverVatNumber': json['receiverVatNumber'] == null ? undefined : json['receiverVatNumber'],
        'invoiceReceiptId': json['invoiceReceiptId'] == null ? undefined : json['invoiceReceiptId'],
        'taxPayerId': json['taxPayerId'] == null ? undefined : json['taxPayerId'],
        'customerNumber': json['customerNumber'] == null ? undefined : json['customerNumber'],
        'accountNumber': json['accountNumber'] == null ? undefined : json['accountNumber'],
        'poNumber': json['poNumber'] == null ? undefined : json['poNumber'],
        'invoiceReceiptDate': json['invoiceReceiptDate'] == null ? undefined : json['invoiceReceiptDate'],
        'orderDate': json['orderDate'] == null ? undefined : json['orderDate'],
        'dueDate': json['dueDate'] == null ? undefined : json['dueDate'],
        'deliveryDate': json['deliveryDate'] == null ? undefined : json['deliveryDate'],
        'total': json['total'] == null ? undefined : json['total'],
        'subtotal': json['subtotal'] == null ? undefined : json['subtotal'],
        'tax': json['tax'] == null ? undefined : json['tax'],
        'serviceCharge': json['serviceCharge'] == null ? undefined : json['serviceCharge'],
        'gratuity': json['gratuity'] == null ? undefined : json['gratuity'],
        'discount': json['discount'] == null ? undefined : json['discount'],
        'shippingHandlingCharge': json['shippingHandlingCharge'] == null ? undefined : json['shippingHandlingCharge'],
        'priorBalance': json['priorBalance'] == null ? undefined : json['priorBalance'],
        'amountDue': json['amountDue'] == null ? undefined : json['amountDue'],
        'amountPaid': json['amountPaid'] == null ? undefined : json['amountPaid'],
        'paymentTerms': json['paymentTerms'] == null ? undefined : json['paymentTerms'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'addressBlock': json['addressBlock'] == null ? undefined : json['addressBlock'],
        'street': json['street'] == null ? undefined : json['street'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'country': json['country'] == null ? undefined : json['country'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'useSingularTaxRate': json['useSingularTaxRate'] == null ? undefined : json['useSingularTaxRate'],
        'singularTaxRate': json['singularTaxRate'] == null ? undefined : json['singularTaxRate'],
        'lineItems': json['lineItems'] == null ? undefined : (json['lineItems'].map(LineItemFromJSON)),
        'isApproved': json['isApproved'] == null ? undefined : json['isApproved'],
    };
}
export function UpdateDocumentRequestToJSON(json) {
    return UpdateDocumentRequestToJSONTyped(json, false);
}
export function UpdateDocumentRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'fileTags': value['fileTags'],
        'vendorName': value['vendorName'],
        'vendorAddress': value['vendorAddress'],
        'vendorPhone': value['vendorPhone'],
        'vendorUrl': value['vendorUrl'],
        'vendorAbnNumber': value['vendorAbnNumber'],
        'vendorGstNumber': value['vendorGstNumber'],
        'vendorPanNumber': value['vendorPanNumber'],
        'vendorVatNumber': value['vendorVatNumber'],
        'receiverName': value['receiverName'],
        'receiverAddress': value['receiverAddress'],
        'receiverPhone': value['receiverPhone'],
        'receiverAbnNumber': value['receiverAbnNumber'],
        'receiverGstNumber': value['receiverGstNumber'],
        'receiverPanNumber': value['receiverPanNumber'],
        'receiverVatNumber': value['receiverVatNumber'],
        'invoiceReceiptId': value['invoiceReceiptId'],
        'taxPayerId': value['taxPayerId'],
        'customerNumber': value['customerNumber'],
        'accountNumber': value['accountNumber'],
        'poNumber': value['poNumber'],
        'invoiceReceiptDate': value['invoiceReceiptDate'],
        'orderDate': value['orderDate'],
        'dueDate': value['dueDate'],
        'deliveryDate': value['deliveryDate'],
        'total': value['total'],
        'subtotal': value['subtotal'],
        'tax': value['tax'],
        'serviceCharge': value['serviceCharge'],
        'gratuity': value['gratuity'],
        'discount': value['discount'],
        'shippingHandlingCharge': value['shippingHandlingCharge'],
        'priorBalance': value['priorBalance'],
        'amountDue': value['amountDue'],
        'amountPaid': value['amountPaid'],
        'paymentTerms': value['paymentTerms'],
        'currency': value['currency'],
        'addressBlock': value['addressBlock'],
        'street': value['street'],
        'city': value['city'],
        'state': value['state'],
        'country': value['country'],
        'zipCode': value['zipCode'],
        'useSingularTaxRate': value['useSingularTaxRate'],
        'singularTaxRate': value['singularTaxRate'],
        'lineItems': value['lineItems'] == null ? undefined : (value['lineItems'].map(LineItemToJSON)),
        'isApproved': value['isApproved'],
    };
}
